import React, { useEffect } from 'react';
import TickBox from './TickBox';

// Bottom sheet at 90% of the screen, shared by moodboard collections and
// highlight playlists. Selection lives in the header; there is no footer.
const Drawer = ({
  open,
  title,
  meta,
  checked,
  tickLabel,
  locked,
  fill,
  onToggle,
  onClose,
  children
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    // The page must not scroll behind the sheet.
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = previous;
    };
  }, [open, onClose]);
  if (!open) return null;
  return React.createElement("div", {
    className: "cp-drawer-scrim",
    onClick: onClose
  }, React.createElement("div", {
    className: "cp-drawer",
    onClick: e => e.stopPropagation()
  }, React.createElement("div", {
    className: "cp-drawer-head"
  }, React.createElement("button", {
    type: "button",
    className: "cp-drawer-tick",
    onClick: onToggle,
    "aria-label": tickLabel,
    title: tickLabel,
    disabled: locked
  }, React.createElement(TickBox, {
    checked: checked
  })), React.createElement("div", {
    className: "cp-drawer-titles"
  }, React.createElement("div", {
    className: "cp-drawer-title"
  }, title), React.createElement("div", {
    className: "cp-drawer-meta"
  }, meta)), React.createElement("button", {
    type: "button",
    className: "cp-drawer-close",
    onClick: onClose,
    "aria-label": "Close"
  }, React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M18 6L6 18M6 6l12 12"
  })))), React.createElement("div", {
    className: `cp-drawer-body${fill ? ' is-fill' : ''}`
  }, children)));
};
export default Drawer;
